import React from 'react';
import styles from '../LandingForm.module.scss';
import { CommonHash } from 'app/types';
import { Field } from 'formik';

interface ImageProps {
  component: CommonHash;
  name: string;
  required?: boolean;
  handleChange: {
    (e: React.ChangeEvent<any>): void;
    <T = string | React.ChangeEvent<any>>(field: T): T extends React.ChangeEvent<any>
      ? void
      : (e: string | React.ChangeEvent<any>) => void;
  };
}
const ImageElement = ({
  component,
  name,
  required,
  handleChange,
}: ImageProps): React.ReactElement => {
  return (
    <div className={styles.group}>
      <div className="d-flex align-items-center gap-2 mb-1">
        <label htmlFor={`${name}.image`}>Image</label>
        {component.image_file && (
          <i
            className="bi bi-trash"
            onClick={() => {
              handleChange({
                target: {
                  name: `${name}.image_file`,
                  value: '',
                },
              });
              handleChange({
                target: {
                  name: `${name}.image_name`,
                  value: '',
                },
              });
            }}
          />
        )}
      </div>
      {component.image_file && !(component.image_file instanceof File) && (
        <div className="d-flex align-items-center gap-2">
          {component.image_name}
          <i className="bi bi-download" onClick={() => window.open(component.image_file)} />
        </div>
      )}
      {component.image_file && (
        <img
          src={
            component.image_file instanceof File
              ? URL.createObjectURL(component.image_file)
              : component.image_file
          }
          className={`my-2 ${styles.image}`}
        />
      )}
      <Field
        type="file"
        id={`${name}.image`}
        name={`${name}.image`}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          const files = event.currentTarget.files;
          if (files !== null) {
            handleChange({
              target: {
                name: `${name}.image_file`,
                value: files[0],
              },
            });
            handleChange({
              target: {
                name: `${name}.image_name`,
                value: files[0].name,
              },
            });
          }
        }}
        required={required && !component.image_file ? true : false}
      />
    </div>
  );
};

export default ImageElement;
